// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadInputStyle_wrapper__eqjHR"};